export default "/etc.clientlibs/pg/clientlibs/clientlib-site/resources/images/e4065554de1d8b07af46b08704ab4cbc.svg";